import adminIdex from './index'

const userControl = () => import('./../../components/UserControl')
const userLoginHistory = () => import('./../../views/admin/userLoginHistory')
const dataHistory = () => import('./../../components/DataHistory')
const historyScenarioControl = () => import('./../../components/HistoryScenarioControl')
const socketCommStatusControl = () => import('./../../components/SocketCommStatusControl')
const socketCommStatusDetail = () => import('./../../components/SocketCommStatusDetail')
const socketCommHistoryDetail = () => import('./../../components/SocketCommHistoryDetail')
const socket = () => import('./SocketNew')
const historyAccessControl = () => import('./../../components/HistoryAccessControl')
const remoteMission = () => import('./../../components/RemoteMission')
const simpleCurrentData = () => import('./../../components/SimpleCurrentData')
const errorRecordControl = () => import('./../../components/ErrorRecordControl')

export default [
  {
    path: '/admin',
    name: 'admin',
    redirect: '/admin/dataHistory',
    component: adminIdex,
    children: [
      {
        path: 'simpleCurrentData',
        name: 'simpleCurrentData',
        component: simpleCurrentData,
      },
      {
        path: 'socket',
        name: 'socket',
        component: socket
      },
      {
        path: 'dataHistory',
        name: 'dataHistory',
        component: dataHistory
      },
      {
        path: 'userControl',
        name: 'userControl',
        component: userControl
      },
      {
        path: 'userLoginHistory',
        name: 'userLoginHistory',
        component: userLoginHistory
      },
      {
        path: 'historyScenarioControl',
        name: 'historyScenarioControl',
        component: historyScenarioControl
      },
      {
        path: 'socketCommStatusControl',
        name: 'socketCommStatusControl',
        component: socketCommStatusControl
      },
      {
        path: 'socketCommStatusDetail',
        name: 'socketCommStatusDetail',
        component: socketCommStatusDetail
      },
      {
        path: 'socketCommHistoryDetail',
        name: 'socketCommHistoryDetail',
        component: socketCommHistoryDetail
      },
      {
        path: 'historyAccessControl',
        name: 'historyAccessControl',
        component: historyAccessControl
      },
      {
        path: 'errorRecord',
        name: 'errorRecord',
        component: errorRecordControl
      },
      {
        path: 'remoteMission',
        name: 'remoteMission',
        component: remoteMission
      },
    ]
  }
]
